export default "__VITE_ASSET__Cd56ApcJ__"